export default __webpack_public_path__ + "static/media/fk.55f09b0a.svg";